<template>
    <main-layout>
        <template #header>
            <main-header :title="'장치 상세 정보' | translate"/>
        </template>
        <template #toolbar>
            <v-btn
                style="align-self: flex-end"
                color="primary"
                small
                @click="totalRqRefresh"
            >
                새로고침
            </v-btn>
        </template>
        <template #body>
            <div class="total-wrapper">

                <div class="contents-container">
                    <!--                    장치 상세 정보 부분입니다.-->
                    <div class="contents-wrapper">
                        <div class="label-button-wrapper">
                            <h3 class="label-wrapper">
                                <span class="label-square"></span>
                                {{ '장치 상세 정보' | translate }}
                            </h3>
                        </div>
                        <tag-table
                            :headers="headers.devices"
                            :items="items.devices"
                            :table-style="tableStyle.device"
                        >
                            <template #cell-useYn="{item}">
                                <y-n-button-flag
                                    :what-type-name="'device'"
                                    :id-key-name="'tnDeviceId'"
                                    :flag-key-name="'useYn'"
                                    :serial="Number(item.tnDeviceId)"
                                    :button-flag="item.useYn"
                                    @refresh-data-load="deviceInfoTableLoad"
                                />
                            </template>
                            <template #cell-deleteYn="{item}">
                                <y-n-button-flag
                                    :what-type-name="'device'"
                                    :id-key-name="'tnDeviceId'"
                                    :flag-key-name="'deleteYn'"
                                    :serial="Number(item.tnDeviceId)"
                                    :button-flag="item.deleteYn"
                                    @refresh-data-load="deviceInfoTableLoad"
                                />
                            </template>
                        </tag-table>
                    </div>

                    <!--명령어 전송 부분입니다.-->
                    <div class="contents-wrapper">
                        <div class="label-button-wrapper">
                            <h3 class="label-wrapper">
                                <span class="label-square"></span>
                                {{ '명령어 전송 이력' | translate }}
                            </h3>
                            <div class="button-wrapper">
                                <v-btn
                                    color="primary"
                                    small
                                    class="button-between-margin"
                                    @click="()=>clickCommandModal('open')"
                                >
                                    명령어 등록
                                </v-btn>
                            </div>
                        </div>
                        <tag-table
                            :table-style="tableStyle.cmd"
                            :headers="headers.cmd"
                            :items="items.cmd"
                        >
                            <template #cell-data="{item}"
                            >
                                <div class="short-text"
                                     @click="()=>clickOpenAlert(item.data)"
                                     >
                                    {{item.data}}
                                </div>
                            </template>
                            <template #cell-result="{item}"
                            >
                                <div class="short-text"
                                     @click="()=>clickOpenAlert(item.result)"
                                >
                                    {{item.data}}
                                </div>
                            </template>
                            <template #cell-status="{item}">
                                {{statusDataChange(item.status)}}

                            </template>
                            <template #cell-result="{item}">
                                {{resultDataChange(item.result)}}
                            </template>
                        </tag-table>
                    </div>

                    <!--연결된 프린터 목록 부분입니다.-->
                    <div class="contents-wrapper">
                        <div class="label-button-wrapper">
                            <h3 class="label-wrapper">
                                <span class="label-square"></span>
                                {{ '연결된 프린터 목록' | translate }}
                            </h3>
                        </div>
                        <!--연결된 프린터 목록 테이블-->
                        <tag-table
                            :table-style="tableStyle.connected"
                            :headers="headers.connectedPrinters"
                            :items="connectedPrintListWithStatus"
                        >
                            <template #cell-disconnect="{item}">
                                <v-btn
                                    v-if="Number(item.cmdStatus)===0"
                                    color="indigo"
                                    class="mx-2"
                                    fab
                                    dark
                                    height="20px"
                                    width="20px"
                                    @click="()=>onCmdEventButtonClick(101,item)"
                                >
                                    <v-icon dark
                                            size="15"
                                    >
                                        mdi-minus
                                    </v-icon>
                                </v-btn>
                                <div v-else>{{statusDataChange(item.cmdStatus)}}</div>
                            </template>
                            <template #cell-deleteYn="{item}">
                                <y-n-button-flag
                                    :what-type-name="'printer'"
                                    :id-key-name="'monitoringPrinterId'"
                                    :flag-key-name="'deleteYn'"
                                    :serial="item.monitoringPrinterId"
                                    :button-flag="item.deleteYn"
                                    @refresh-data-load="searchedPrintListLoad('Y')"
                                />
                            </template>
                            <template #cell-removeYn="{item}">
                                <y-n-button-flag
                                    :what-type-name="'printer'"
                                    :id-key-name="'monitoringPrinterId'"
                                    :flag-key-name="'removeYn'"
                                    :serial="item.monitoringPrinterId"
                                    :button-flag="item.removeYn"
                                    @refresh-data-load="searchedPrintListLoad('Y')"
                                />
                            </template>
                            <template #cell-wsd="{item}">
                                <div>{{activeDataChange(item.wsd)}}</div>
                            </template>
                            <template #cell-p9100="{item}">
                                {{activeDataChange(item.p9100)}}
                            </template>
                        </tag-table>
                    </div>

                    <!--검색된 프린터 목록-->
                    <div class="contents-wrapper">
                        <div class="label-button-wrapper">
                            <h3 class="label-wrapper">
                                <span class="label-square"></span>
                                {{ '검색된 프린터 목록' | translate }}
                            </h3>
                            <div class="button-wrapper">
                                <v-btn
                                    color="primary"
                                    small
                                    class="button-between-margin"
                                    @click="()=>onCmdEventButtonClick(304)"
                                >
                                    프린트 검색
                                </v-btn>
                            </div>
                        </div>
                        <tag-table
                            :table-style="tableStyle.searched"
                            :headers="headers.searchedPrinters"
                            :items="searchedPrintListWithStatus">
                            <template #cell-searched="{item}">
                                <v-btn
                                    v-if="Number(item.cmdStatus)===0"
                                    color="indigo"
                                    class="mx-2"
                                    fab
                                    dark
                                    height="20px"
                                    width="20px"
                                    @click="()=>onCmdEventButtonClick(100,item)"
                                >
                                    <v-icon dark
                                            size="15"
                                    >
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                                <div v-else>{{statusDataChange(item.cmdStatus)}}</div>
                            </template>

                        </tag-table>
                    </div>
                </div>

                <!--명령어 상세 ,명령어 등록 클릭시 나오는 모달입니다.-->
                <command-modal
                    :is-dialog="isDialog"
                    :items="items"
                    :connected-print-list-with-status="connectedPrintListWithStatus"
                    :searched-print-list-with-status="searchedPrintListWithStatus"
                    @click-command-modal="clickCommandModal"
                    @cmd-insert-data-load="cmdInsertDataLoad"
                />

                <!--요청시 나오는 로딩 입니다.-->
                <div class="loading_wrap" v-show="isLoading">
                    <div class="loading"></div>
                    <div class="loading"></div>
                    <div class="loading"></div>
                </div>
            </div>

        </template>

    </main-layout>
</template>

<script>
/**
 * 장치 상세 정보 부분입니다.
 * 장치 목록에서 테이블 데이터중 하나를 클릭했을때 나오는 페이지 입니다
 * tnDeviceId 데이터를 전달받아 테이블 데이터 요청을 보냅니다.
 * 명령어들을 관리해서 장치와 프린트 를 컨트롤 합니다.
 */
/**
 * status 상태값
 * 1: 요청, 2: 처리중, 3: 처리완료, 4: 보류, 0: 요청도 안보낸 상태(computed 할때 추가)
 *
 */
import MainLayout from "@/components/common/layout/MainLayout";
import MainHeader from "@/components/common/layout/MainHeader";
import {PATH} from "@/constants";
import TagTable from "@/components/TagTable/TagTable";
import headerDataList from "@/components/TagTable/headerDataList";
import CommandModal from "@/views/monitoring/deviceList/CommandModal";
import selectOptions from "@/components/selectBox/selectOptions";
import YNButtonFlag from "@/views/monitoring/deviceList/YNButtonFlag";



export default {
    name: "DeviceDetail",
    components: {
        YNButtonFlag,
        TagTable,
        MainLayout,
        MainHeader,
        CommandModal

    },
    data() {
        return {
            headers: { //ATable.vue에서 header 부분 데이터입니다. body에도 사용됩니다.
                devices: headerDataList.DEVICE_DETAIL.DEVICES,
                cmd: headerDataList.DEVICE_DETAIL.CMD,
                connectedPrinters: headerDataList.DEVICE_DETAIL.CONNECTED,
                searchedPrinters: headerDataList.DEVICE_DETAIL.SEARCHED
            },
            items: { //테이블에 필요한 데이터 입니다.
                devices: [],
                cmd: [],
                connectedPrinters: [],
                searchedPrinters: []
            },
            isLoading: false,
            isDialog: false,
            tableStyle:{//table style 속성을 지정합니다.
                connected: {
                    width:'350',
                    tableLayout:'fixed'

                },
                searched:{
                    width:'100',
                },
                cmd:{
                    width:'100',
                    tableLayout:'fixed'
                },
                device:{
                    width:'180'
                }

            }
        }
    },
    computed: {
        /**
         * 연결된 프린터에서 삭제중인지 상태값(cmdStatus)을 저장해서 반환한다
         */
        connectedPrintListWithStatus(){
            return this.getPrinterListWithStatus(this.items.connectedPrinters,this.items.cmd,101)
        },
        /**
         * 검색된 프린터에서 등록인지 상태값(cmdStatus) 저장해서 반환한다
         */
        searchedPrintListWithStatus(){
            return this.getPrinterListWithStatus(this.items.searchedPrinters,this.items.cmd,100)
        }

    },
    methods: {
        /**
         * cmd의 상태값을 프린트 목록에 추가하는 로직입니다
         * cmdStatus로 status의 값을 추가합니다.
         * 아직 요청을 수행하지 못할 경우(즉 cmd 목록에 해당 프린트가 없을경우) 0 으로 값을 저장합니다.
         *
         * @param printerList
         * @param commandList
         * @returns {*[]|*}
         */
        getPrinterListWithStatus(printerList, commandList,cmd){
            if (!Array.isArray(printerList) || printerList.length === 0) return [];
            return printerList.map(printer => {
                printer.cmdStatus=0
                for (let i = 0; i < commandList.length; i++) {
                    const command = commandList[i];
                    const sameCmd = cmd === command.cmd
                    const sameSerial = printer.serialNo && (printer.serialNo === command.printerSerialNo)
                    if (sameCmd && sameSerial) {
                        printer.cmdStatus = command.status;
                        return printer;
                    }
                    printer.cmdStatus=0
                }

                return printer;
            });
        },
        /**
         * 장치 상세 목록중 status 값을 변환하여 테이블에 표기합니다.
         * 연결된 프린트 or 검색된 프린트 목록에서는 아이콘 표기 대신 text로 합니다.
         * @param status
         * @returns {string}
         */
        statusDataChange(status){
            let statusNumber = Number(status)
            if(statusNumber ===1) return '요청'
            else if(statusNumber ===2) return '처리중'
            else if(statusNumber ===3) return '처리완료'
            else if(statusNumber ===4) return '보류'
            else return ''
        },
        /**
         * 장치 상세 목록중 result 값을 변환하여 테이블에 표기합니다.
         * @param status
         * @returns {string}
         */
        resultDataChange(result){
            let resultNumber = Number(result)
            if(resultNumber ===0) return '요청'
            else if(resultNumber ===1) return '처리중'
            else return '초기값'
        },
        /**
         * 프린트 목록중 active 값을 변환하여 테이블에 표기합니다.
         * @param status
         * @returns {string}
         */
        activeDataChange(active){
            if(active ==='enabled') return '활성화'
            else if(active ==='disabled') return '비활성화'
            else return ''
        },
        /**
         * 명령어를 요청할때 필수 데이터가 있는지 체크하는 로직입니다.
         * 기본적으로 명령어와 프린트 데이터를 받습니다
         * true: 요청에 필요한 데이터가 없습니다
         * false: 요청에 필요한 전부 데이터가 있습니다 or 체크할 필수 데이터가 없습니다.
         * @param cmd
         * @param printData
         * @returns {boolean}
         */
        noRequiredPrintData(cmd,printData){
            const selectedCmd = selectOptions.DEVICE_DETAIL.CMD_OPTIONS.find(({codeKey})=> codeKey === cmd)
            if(!selectedCmd.validateCheckData) return false
            return selectedCmd.validateCheckData.some((checkData)=> !printData[checkData])
        },
        /**
         * 프린트 검색(304), 등록(100), 삭제(101)를 클릭시 동작하고
         * 요청에 필요한 데이터가 있는지 validation 을 체크합니다.
         * @param cmd
         * @param item
         */
        onCmdEventButtonClick(cmd,item){
            const isValidate = this.noRequiredPrintData(cmd,item)
            if(isValidate) {
                alert("명령어에 필요한 데이터가 없습니다.")
                return
            }
            const reqItem ={cmd,...item}
            if(cmd === 100) reqItem.printerSerialNo=item.serialNo//검색된 프린트는 printerSerialNo가 없을수도 있다
            this.cmdInsertDataLoad(reqItem)
        },

        /**
         * alert창을 띄워 춥니다.
         */
        clickOpenAlert(data){
            this.$alert(`명령어 내용 \n${data}`)
        },

        /**
         * 모달창을 열고 닫습니다.
         */
        clickCommandModal(role) {
            this.isDialog = role==='open'
        },
        /**
         * 새로고침을 누르거나 명령어 등록 삭제를 할때 명령어전송, 연결된, 검색된 프린트 이력을
         * 다시 refresh합니다.
         */
        totalRqRefresh(){
            Promise.all([
                this.deviceInfoTableLoad(),
                this.cmdListTableLoad(),
                this.searchedPrintListLoad('Y'),
                this.searchedPrintListLoad('N')
            ]).catch((err)=>{
                console.log(err)
            })
        },

        /**
         * 장치 상세 정보의 테이블 데이터들을 가져옵니다.
         */
        async deviceInfoTableLoad() {
            this.isLoading = true;
            const res = await this.$request(`${PATH.MONITORING.DEVICE_DETAIL}/${this.$route.query.tnDeviceId}`)
                .get()
                .catch((e) => {
                    this.isLoading = false;
                    alert('조회실패')
                })
                .enqueue()
            this.items.devices = [res]
            this.isLoading = false;
        },
        /**
         * 명령어 전송 이력의 데이터를 가져옵니다.
         * @returns {Promise<void>}
         */
        async cmdListTableLoad() {

            const {rentalcompanyId, tnDeviceId, deviceType} = this.$route.query
            this.isLoading = true;
            const res = await this.$request(`${PATH.CMD.CMD_LIST}`)
                .setObject({
                    rentalcompanyId,
                    tnDeviceId,
                  deviceType
                })
                .catch((e) => {
                    this.isLoading = false;
                    alert('조회실패')
                })
                .enqueue()
          console.log('### res.data')
            this.items.cmd = [...res.data]
            this.isLoading = false;
        },

        /**
         * 연결된 프린트 목록과 검색된 프린트 목록의 데이터를 가져오는
         * 요청 함수입니다.
         * @param registStatus
         * @returns {Promise<void>}
         */
        async searchedPrintListLoad(registStatus) {
            const {rentalcompanyId, tnDeviceId} = this.$route.query
            this.isLoading = true;
            const res = await this.$request(`${PATH.MONITORING.SEARCHED_LIST}`)
                .setObject({
                    rentalcompanyId,
                    tnDeviceId,
                    registStatus,

                })
                .catch((e) => {
                    this.isLoading = false;
                    alert('조회실패')
                })
                .enqueue()
            if (registStatus === 'Y') this.items.connectedPrinters = [...res.data]
            else this.items.searchedPrinters = [...res.data]
            this.isLoading = false;

        },

        /**
         * 명령어를 등록할때 필요한 요청 함수입니다
         * 명령어 검색(304), 삭제(101), 등록(100), 명령어 등록(통합) 시 동작합니다.
         * @param body
         * @returns {Promise<void>}
         */
        async cmdInsertDataLoad(body) {
            this.isDialog=false
            const {rentalcompanyId, tnDeviceId,accountId, deviceType} = this.$route.query

            this.isLoading = true;
            const res = await this.$request(`${PATH.CMD.CMD_INSERT}`)
                .setObject({
                    rentalcompanyId,
                    tnDeviceId,
                    accountId,
                    ...body,
                    status:1,
                  deviceType

                })
                .catch((e) => {
                    this.isLoading = false;
                    alert('명령어 등록 실패')
                })
                .enqueue()
            if(res ===1) alert("명령어 전송이 완료됐습니다.")
            this.totalRqRefresh()
            this.isLoading = false;
        },

    },
    created() {
        // this.deviceInfoTableLoad()
        this.totalRqRefresh()
    },
    /**
     * 장치목록에서 칼럼을 클릭할때 장치 상세페이지로 가는데 그때만 파라미터가 넘어옵니다.
     * 그외 (url로 입력하고 들어갈때) 상황에는 잘못된 경로이기때문에 뒤로가기로 처리했습니다.
     *
     */
    beforeCreate() {
        if (!this.$route.query.tnDeviceId || !this.$route.query.rentalcompanyId) {
            this.$router.go(-1)
            alert("올바른 페이지 접근 방법이 아닙니다.")
        }
    }
}
</script>

<style scoped>
.total-wrapper {
    height: 100%;
}

.contents-container {
    display: flex;
    flex-direction: column;
    height: 93%; /*100%로 하면 하단에 열이 3개정도 짤립니다.*/
    overflow-y: auto;
}

.contents-wrapper {
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
}

.label-button-wrapper {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px
}

.label-wrapper {
    font-size: 20px;
    font-weight: bold;
    line-height: 40px;
    align-self: flex-start;
}

.label-square {
    width: 3px;
    height: 3px;
    background: #333;
    display: inline-block;
    line-height: 20px;
    position: relative;
    top: -4px;
    margin: 0 7px 0 0;
}

.button-wrapper {
    align-self: flex-end
}

.button-between-margin {
    margin-right: 10px
}
.short-text{
    text-overflow:ellipsis;
    overflow:hidden;
    white-space:nowrap;
}

.loading_wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    background: rgba(0, 0, 0, 0.5);
}

.loading {
    width: 8px;
    height: 8px;
    background: #aaaaaa;
    border-radius: 50%;
    animation: loading-cricle 1.5s infinite ease-in-out;
    display: inline-block;
    margin-right: 8px;
}

.loading:nth-child(2) {
    animation-delay: .5s;
}

.loading:nth-child(3) {
    animation-delay: 1s;
}

@keyframes loading-cricle {
    0% {
        opacity: .4;
        transform: scale(1, 1);
    }
    50% {
        opacity: 1;
        transform: scale(1.2, 1.2);
    }
    100% {
        opacity: .4;
        transform: scale(1, 1);
    }
}

/*Search Box 부분 font 랑 사이즈 조정 부분입니다*/
>>> .v-input__control .v-input__slot .v-text-field__slot input {
    font-size: 11px;
    padding: 0;
}

>>> .v-input__control .v-input__slot fieldset {
    height: 47px;
}



</style>